export default "__VITE_ASSET__zP$Ql9eE__"